export class Permissoes {
    static create() {
        return {
            comandos: true,
            financeiro: false,
            ordem_servico: false,
            cacontrol: false
        };
    }
}
